// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryMegaMenu_root__bDB_D"};